import { h, Component } from 'preact';
import cssStyles from './index.css';
import { VastIconType } from '../../lib/vast/vast-icon';
import {
  cleanAnalyticsStoredEventSending,
  sendCreativeOptoutTrack
} from '../../../../common/js/TrackAnalyticsHelper';

interface Props {
  icon: VastIconType;
  style?: h.JSX.CSSProperties;
  imageStyle?: h.JSX.CSSProperties;
  onClick?: (url: string) => void;
}

class VastIcon extends Component<Props> {
  constructor(props: Props) {
    super(props);
  }

  render() {
    const { icon, style, imageStyle, onClick } = this.props;
    return (
      <div
        id="vast_icon"
        className={cssStyles.icon}
        style={style}
        onTouchStart={(e: TouchEvent) => e.stopPropagation()}
        onClick={(e: MouseEvent) => {
          e.stopPropagation();
          cleanAnalyticsStoredEventSending();
          sendCreativeOptoutTrack();

          if (icon.tracking?.click) {
            new Image().src = icon.tracking.click;
          }

          if (icon.tracking?.clickThrough && onClick) {
            onClick(icon.tracking.clickThrough);
          }
        }}
      >
        <img src={icon.url} alt="" style={imageStyle} />
      </div>
    );
  }
}

export default VastIcon;
